// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__uSwgU","title":"Info_title__3zQfq","links":"Info_links__3j6hX","link":"Info_link__2Ub0c","logo":"Info_logo__2RInD"};